export const timeout = async (timeout: number) => new Promise<void>((resolve) => setTimeout(resolve, timeout));
